var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 31,
    viewBox: "0 0 38 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5909H36M32.9643 29H5.03571C4.23059 29 3.45845 28.6767 2.88914 28.1014C2.31983 27.526 2 26.7456 2 25.9318V5.06818C2 4.25445 2.31983 3.47405 2.88914 2.89865C3.45845 2.32325 4.23059 2 5.03571 2H10.7952C11.3946 2.00002 11.9806 2.17937 12.4793 2.51545L14.5921 3.93909C15.0908 4.27518 15.6768 4.45453 16.2762 4.45455H32.9643C33.7694 4.45455 34.5416 4.7778 35.1109 5.3532C35.6802 5.92859 36 6.70899 36 7.52273V25.9318C36 26.7456 35.6802 27.526 35.1109 28.1014C34.5416 28.6767 33.7694 29 32.9643 29Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBanco);
export default __webpack_public_path__ + "static/media/icon-banco.81addcfc9914b083cc15fabfcff88f25.svg";
export { ForwardRef as ReactComponent };